<template>
    <div class="container-fluid">
        <form @submit.prevent="handleSubmit" ref="form" class="row">
            <div class="col-lg-6">
                <div class="card card-blue">
                    <div class="card-header">
                        <h4 class="card-title">Label Inputs</h4>
                        <h6 class="card-subtitle">Create label from SKU</h6>
                    </div>

                    <div class="card-body row pb-0">
                        <div class="form-group col-6">
                            <label for="brand">Brand</label>
                            <input type="text" required v-model="brand" class="form-control" id="brand" name="brand" placeholder="Brand">
                        </div>

                        <div class="form-group col-6">
                            <label for="sku">Select SKU</label>
                            <input v-if="productid" required type="text" :value="product?product.code:null" name="sku" disabled class="form-control" id="sku">
                            <multiselect v-else required
                                         :clear-on-select="false"
                                         :close-on-select="true"
                                         :hide-selected="true"
                                         :internal-search="false"
                                         :options="products"
                                         :searchable="true"
                                         :selectLabel="''"
                                         :show-no-results="false"
                                         class="form-control multiselect-sm"
                                         id="sku2"
                                         @search-change="searchProduct"
                                         @input="setProduct"
                                         name="sku"
                                         open-direction="bottom"
                                         label="Search SKU"
                                         placeholder="Search SKU"
                                         v-model="product">
                                <template slot="singleLabel" slot-scope="props">
                                    {{ props.option.code }}
                                </template>
                                <template slot="option" slot-scope="props">
                                    <div class="option__desc">
                                        <h5>{{ props.option.code }}</h5>
                                        <h6>{{ props.option.commodity_name }}</h6>
                                        <h6>{{ props.option.quantity }} {{ props.option.unit }}</h6>
                                    </div>
                                </template>
                                <span slot="noResult">SKU not found</span>
                            </multiselect>
                        </div>

                        <div class="form-group col-6">
                            <label for="good">Product</label>
                            <input type="text"
                                   required
                                   class="form-control"
                                   id="good"
                                   name="good"
                                   v-model="good"
                                   placeholder="Product">
                        </div>

                        <div class="form-group col-6">
                            <label for="good">Quantity</label>
                            <div class="input-group">
                                <input type="number" required name="qunit" class="form-control" id="qunit" v-model="quantity" placeholder="Quantity">
                                <div class="input-group-append">
                                    <span class="input-group-text">{{ unit }}</span>
                                </div>
                            </div>
                        </div>

                        <div class="form-group col-6">
                            <label for="pkgdt">Package Date</label>
                            <input id="pkgdt" name="pkgdt" type="text" placeholder="DD-MM-YYYY" class="form-control" v-model="date">
                        </div>

                        <div class="form-group col-6">
                            <label for="actQty">Use By</label>
                            <div class="input-group">
                                <input type="text" id="duedt" placeholder="DD-MM-YYYY" class="form-control" v-model="duedt">
                            </div>
                        </div>

                        <div class="form-group col-6">
                            <label for="price">Unit Price</label>
                            <div class="input-group">
                                <input id="price" type="number" step="any" placeholder="Unit Price" class="form-control" v-model="unit_price">
                                <div class="input-group-append">
                                    <span class="input-group-text">{{ currency }}</span>
                                </div>
                            </div>
                        </div>

                        <div class="form-group col-6">
                            <label for="tprice">Total Price</label>
                            <div class="input-group">
                                <input id="tprice" type="number" step="any" placeholder="Total Price" class="form-control" v-model="total_price">
                                <div class="input-group-append">
                                    <span class="input-group-text">{{ currency }}</span>
                                </div>
                            </div>
                        </div>

                        <div class="form-group col-6">
                            <label for="qr">Provenance</label>
                            <input id="qr" type="url" placeholder="Provenance" class="form-control" v-model="qr">
                            <small class="form-text text-muted">URL Protocol is required, i.e. http, https, etc.</small>
                        </div>

                        <div class="form-group col-6">
                            <label for="fssai">FSSAI</label>
                            <input id="fssai" type="text" placeholder="FSSAI No" class="form-control" v-model="fssai">
                        </div>
                    </div>

                    <div class="card-footer text-right" style="height: 58px;">
                    </div>
                </div>
            </div>
            <div class="col-lg-6">
                <div class="card card-blue">
                    <div class="card-header">
                        <h4 class="card-title">Label Preview</h4>
                        <h6 class="card-subtitle">Actual PDF may differ</h6>
                    </div>
                    <div class="card-body">
                        <div class="form-group row">
                            <label for="staticEmail" class="col-sm-6 col-form-label text-right">Brand Font Size :</label>
                            <div class="col-sm-3">
                                <select class="form-control" v-model="font" id="label-font">
                                    <option :value="18">18px</option>
                                    <option :value="16">16px</option>
                                    <option :value="15">15px</option>
                                    <option :value="14">14px</option>
                                </select>
                            </div>
                        </div>
                        <div class="border ml-auto mr-auto mt-2 mb-5;"
                             style="width: 361px;
                                padding: 10px;
                                background-color: white;
                                height: 173px;">

                            <div style="float: left; width: 50%; font-size: 12px;padding-left: 10px;">
                                <h5 :style="'text-align: left; text-decoration: none; margin-bottom: 0; font-size: ' + font +'px;'">{{ brand }}</h5>
                            </div>
                            <div style="float: right; width: 50%; text-align: right; font-size: 10px;">
                                Pkg Dt: {{date}}<br>
                                FSSAI #: {{ fssai }}
                            </div>
                            <div style="float: left; width: 100%; font-size: 12px;padding-left: 10px;">
                                <span style="text-align: left; margin-bottom: 0;">{{ good }}<br>{{ variety ? variety.charAt(0) : '' }}</span>
                            </div>
                            <!--                            <img src="../../../../assets/images/veg.png" style="width: 20px; height: 20px; position: absolute; margin-left: -20px; margin-top: 20px;"/>-->
                            <div style="float:left; width: 100%">
                                <div style="padding-left: 10px; margin-bottom: 0px;">
                                  <label style="margin: 0; font-size: 11px; width: 50%;">Use By: {{ duedt }}</label>
                                </div>
                            </div>
                            <br>
                            <div style="float:left; width: 100%">
                                <div style="padding-left: 10px; margin-bottom: 0px;">
                                  <label style="margin: 0; font-size: 11px; width: 50%;">Unit Wt./Qty: {{ quantity }} {{ unit }}</label>
                                  <label style="text-align: right; font-size: 11px; width: 50%;margin: 0;">MRP: {{ total_price }} {{ currency }}</label>
                                </div>
                            </div>
                            <svg class="code128" height="100px" style="float:left; margin-top: 5px;"/>
                            <img :src="qrUrl" alt="" v-if="qrUrl" style="float: right; margin-right: -5px; margin-top: -5px;" height="60px">
                        </div>
                        <br>
                        <h5 class="text-center">Barcode Number: {{ code }}</h5>
                        <div class="form-group row mt-5 mb-5">
                            <div class="col-8 offset-4">
                                <div class="form-check">
                                    <input class="form-check-input" type="checkbox" value="" checked id="defaultCheck2" disabled>
                                    <label class="form-check-label" for="defaultCheck2">
                                        Product Code
                                    </label>
                                </div>
                            </div>
                            <div class="col-8 offset-4">
                                <div class="form-check">
                                    <input class="form-check-input" type="checkbox" v-model="flag" id="defaultCheck1">
                                    <label class="form-check-label" for="defaultCheck1">
                                        Quantity
                                    </label>
                                </div>
                            </div>
                            <div class="clearfix"/>
                        </div>
                    </div>
                    <div class="card-footer text-right">
                        <button class="btn btn-outline-primary" type="submit">
                            <i class="fa fa-print"/> Print
                        </button>
                    </div>
                </div>
            </div>
        </form>
        <div class="row mt-4 border hide">
            <div id="paper" style="width: 100%; margin: auto">
                <div style="width: 33%;
                                float: left;
                                padding: 10px;
                                background-color: white;
                                height: 173px;"
                     v-for="i in 24">
                    <div style="float: left; width: 50%; font-size: 12px;padding-left: 10px;">
                        <h5 :style="'text-align: left; text-decoration: none; margin-bottom: 0; font-size:' + font +'px;'">{{brand}}</h5>
                    </div>
                    <div style="float: left; width: 50%; text-align: right; font-size: 10px;">
                        Pkg Dt: {{date}}<br>
                        FSSAI #: {{fssai}}
                    </div>
                    <div style="float:left; width: 100%">
                        <div style="padding-left: 10px; margin-bottom: -5px;">
                          <label style="margin: 0;font-size: 11px;width: 50%;">Use By: {{duedt}}</label>
                        </div>
                        <div style="padding-left: 10px; margin-top: -5px;">
                            <label style="margin: 0; font-size: 11px; width: 50%;">Unit Wt./Qty: {{quantity}} {{unit}}</label>
                            <label style="text-align: right;font-size: 11px;width: 50%;margin: 0;">MRP: {{total_price}} {{currency}}</label>
                        </div>
                    </div>
                    <br>
                    <svg class="code128" height="100px" style="float:left; margin-top: 5px;"/>
                    <img :src="qrUrl" alt="" v-if="qrUrl" style="float: right; margin-right: -5px; margin-top: -5px;" height="60px">
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import JsBarcode from 'jsbarcode';
import QRCode from 'qrcode';
import {mapGetters} from "vuex";
import Multiselect from 'vue-multiselect';
import pad from "pad";

export default {
    name: "MarketplaceSKULabel",
    props: ["productid"],
    computed: {
        ...mapGetters(["currentUser", "currentOrg"])
    },
    components: {Multiselect},
    watch: {
        flag: function(nv, ov) {
            this.generateBarcodeNumber();
        },
        qr: function(nv, ov) {
            this.generateQr();
        },
        code: function(nv, ov) {
            this.generateBar();
        },
        quantity: function (nv, ov) {
            this.total_price = Number(this.quantity) * Number(this.unit_price)
        },
        unit_price: function (nv, ov) {
          this.total_price = Number(this.quantity) * Number(this.unit_price)
        }
    },
    data() {
        return {
            product: null,
            products: [],
            brand: null,
            good: null,
            variety: null,
            quantity: null,
            unit: null,
            actualQuantity: null,
            unit_price: null,
            total_price: null,
            currency: null,
            date: null,
            duedt: null,
            qr: null,
            fssai: null,
            qrUrl: null,
            key1: null,
            val1: null,
            key2: null,
            val2: null,
            // 21 product code,
            // 5 digit product code
            code: "0000000000",
            flag: true,
            font: 18
        }
    },
    mounted() {
        this.currency = this.currentOrg.currency_symbol;
        let self      = this;
        $("#pkgdt").datepicker({format: "dd-mm-yyyy"});
        $("#duedt").datepicker({format: "dd-mm-yyyy"});

        $('#pkgdt').change(function(e) {
            self.date = e.target.value;
        });
        $('#duedt').change(function(e) {
            self.duedt = e.target.value;
        });
        if(this.productid) {
            this.getProduct();
        }
        this.preview();
    },
    methods: {
        async getProduct() {
            try {
                let reply           = await this.$http.get(`/marketplaces/${this.currentOrg.marketplace_id}/products/${this.productid}`);
                this.product        = reply.data;
                this.good           = this.product.name + this.getVariety(this.product.variety);
                this.quantity       = Number(this.product.quantity).toFixed(0);
                this.actualQuantity = Number(this.product.quantity).toFixed(0);
                this.unit           = this.product.unit;
                // this.code           = `${this.product.code.substring(0, 5)}${pad(5, this.quantity, '0')}`;
                this.generateBarcodeNumber();
                console.log(this.code);
            } catch(e) {
                console.error(e);
                this.$toastr('error', 'Stock Keeping Unit not found', 'Failure');
                this.$router.push({name: "products"});
            }
        },
        async searchProduct(search) {
            this.isLoading = true;
            let reply      = await this.$http.get(`/marketplaces/${this.currentOrg.marketplace_id}/products/search`, {
                params: {
                    search
                }
            });
            this.products  = reply.data;
        },
        setProduct() {
            this.good           = this.product.name;
            this.variety        = this.product.variety;
            this.quantity       = Number(this.product.quantity).toFixed(0);
            this.actualQuantity = Number(this.product.quantity).toFixed(0);
            this.unit           = this.product.unit;
            this.generateBarcodeNumber();
            // this.code           = `${this.product.code.substring(0, 5)}${pad(5, this.quantity, '0')}`;
            console.log(this.code);
        },
        preview() {
            this.generateBar();
            this.generateQr();
        },
        generateBar() {
            JsBarcode(".code128", this.code.toString().substring(0, 10), {
                format: "CODE128",
                height: 30,
                fontSize: 10,
                width: 1.8,
                marginLeft: 10,
                marginTop: 0,
                marginRight: 0,
                marginBottom: 0
            });
        },
        async generateQr() {
            let qr = 'https://borlaug.ws';

            if(this.qr && this.qr.trim().length > 0) {
                qr = this.qr;
            }

            this.qrUrl = await QRCode.toDataURL(qr, {
                width: 80,
                type: 'svg',
                color: {
                    dark: '#000',  // Blue dots
                    light: '#0000' // Transparent background
                }
            });
            console.log(this.qrUrl);
        },

        handleSubmit(e) {
            this.submitted = true;
            this.$validator.validate()
                .then(valid => {
                    if(valid) {
                        this.preview();
                        this.$htmlToPaper('paper');
                    }
                });
        },
        generateBarcodeNumber() {
            if(this.flag) {
                // TOKRI changes for amazon
                // this.code = `${this.product ? this.product.code.substring(0, 5) : '00000'}${pad(5, this.quantity || 0, '0')}`;
                this.code = this.product.code;
            } else {
                this.code = `${this.product ? this.product.code.substring(0, 5) : '00000'}`;
            }
        },
        getVariety(variety) {
            if(variety && variety.trim().length > 0) {
                return ` - ${variety}`;
            } else {
                return '';
            }
        }
    }
}
</script>

<style scoped>

</style>
